<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);

const MAX = 4;

const localItems = ref([...(props.modelValue || [])]);

watch(
  () => props.modelValue,
  val => {
    localItems.value = [...(val || [])];
  }
);

const emitItems = next => {
  localItems.value = next;
  emit('update:modelValue', next);
};

const addFeature = () => {
  if (localItems.value.length >= MAX) return;
  emitItems([
    ...localItems.value,
    { icon: 'message-circle', title: '', description: '' },
  ]);
};

const removeFeature = index => {
  emitItems(localItems.value.filter((_, i) => i !== index));
};

const updateField = (index, field, value) => {
  emitItems(
    localItems.value.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    )
  );
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="(feature, index) in localItems"
      :key="index"
      class="flex flex-col gap-2 p-3 border rounded-lg border-n-weak"
    >
      <div class="flex items-center justify-between">
        <span class="text-xs text-n-slate-11">
          {{ $t('REVENDA.BRANDING.LOGIN.FEATURE_N', { n: index + 1 }) }}
        </span>
        <button
          type="button"
          :data-testid="`remove-feature-${index}`"
          class="text-xs text-n-ruby-11 hover:underline"
          @click="removeFeature(index)"
        >
          {{ $t('REVENDA.BRANDING.LOGIN.REMOVE_FEATURE') }}
        </button>
      </div>
      <input
        :data-testid="`feature-icon-${index}`"
        type="text"
        class="w-full"
        :value="feature.icon"
        :placeholder="$t('REVENDA.BRANDING.LOGIN.FEATURE_ICON_PLACEHOLDER')"
        :aria-label="$t('REVENDA.BRANDING.LOGIN.FEATURE_ICON_PLACEHOLDER')"
        @input="updateField(index, 'icon', $event.target.value)"
      />
      <input
        :data-testid="`feature-title-${index}`"
        type="text"
        class="w-full"
        :value="feature.title"
        :placeholder="$t('REVENDA.BRANDING.LOGIN.FEATURE_TITLE')"
        :aria-label="$t('REVENDA.BRANDING.LOGIN.FEATURE_TITLE')"
        @input="updateField(index, 'title', $event.target.value)"
      />
      <input
        :data-testid="`feature-description-${index}`"
        type="text"
        class="w-full"
        :value="feature.description"
        :placeholder="$t('REVENDA.BRANDING.LOGIN.FEATURE_DESCRIPTION')"
        :aria-label="$t('REVENDA.BRANDING.LOGIN.FEATURE_DESCRIPTION')"
        @input="updateField(index, 'description', $event.target.value)"
      />
    </div>
    <button
      v-if="localItems.length < MAX"
      type="button"
      data-testid="add-feature"
      class="flex items-center justify-center gap-1 px-3 py-2 text-sm border rounded-lg text-n-slate-11 border-n-weak hover:bg-n-solid-2"
      @click="addFeature"
    >
      {{ $t('REVENDA.BRANDING.LOGIN.ADD_FEATURE') }}
    </button>
  </div>
</template>
